.checkbox {
  align-items: center;
}
